import type { ServiceAuthFactory } from "../../../services/auth/types";
import { TranscribeAuthAdapter } from "./adapter";

export const transcribeAuthFactory: ServiceAuthFactory = {
  addinKey: "transcribe",
  create(cfg, deps) {
    return new TranscribeAuthAdapter(cfg, deps);
  },
};
